<template>
    <section
        class="border-b border-slate-200 bg-slate-50"
        aria-labelledby="tools-heading"
    >
        <div class="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
            <div class="space-y-8">
                <div>
                    <h2
                        id="tools-heading"
                        class="text-xl font-bold"
                    >
                        Keep your solo business stack simple
                    </h2>
                    <p class="mt-2 text-slate-600">
                        Connect Google Calendar, Outlook Calendar, meeting, and
                        payment tools so every booking stays synced and each
                        client gets a smooth experience.
                    </p>
                </div>
                <ul class="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
                    <li
                        v-for="provider in providers"
                        :key="provider.name"
                        class="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-4"
                    >
                        <div
                            class="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-slate-50"
                            aria-hidden="true"
                        >
                            <Image
                                :src="provider.iconUrl"
                                alt=""
                                class="h-6 w-6 object-contain"
                            />
                        </div>
                        <span
                            class="min-w-0 text-sm font-bold leading-tight text-slate-700"
                        >
                            {{ provider.name }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import Image from '@/Shared/Component/Image.vue'

    interface ProviderIntegration {
        name: string
        iconUrl: string
    }

    const providers: ProviderIntegration[] = [
        {
            name: 'Google Calendar',
            iconUrl: '/static/icons/providers/google-calendar.svg',
        },
        {
            name: 'Outlook Calendar',
            iconUrl: '/static/icons/providers/outlook-calendar.webp',
        },
        {
            name: 'Google Meet',
            iconUrl: '/static/icons/providers/google-meet.svg',
        },
        {
            name: 'Zoom',
            iconUrl: '/static/icons/providers/zoom.svg',
        },
        {
            name: 'Stripe',
            iconUrl: '/static/icons/providers/stripe.svg',
        },
    ]
</script>
